import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import App from './app';
import siteConfig from './config/site.config';
import * as serviceWorker from './serviceWorker';

const appWrapper = (
  <HelmetProvider>
    <Helmet>
      <title>{siteConfig.siteTitle}</title>
    </Helmet>
    <App />
  </HelmetProvider>
);

ReactDOM.render(appWrapper, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
